import { useState, useEffect, CSSProperties } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { toast } from 'react-toastify';
import { useParams, Link } from "react-router-dom";
import { config } from "../../utils/config";
import DatePicker from "react-datepicker";
import { Multiselect } from "multiselect-react-dropdown"
import { tokenDecode } from "../../utils/helper";
import "../../index.css"
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import VerifiedIcon from '@mui/icons-material/Verified';
import brandStyles from "../Brand/Brand.module.css";
import styles from "./UpdateSeller.module.css";
const { apiEndpoint, baseNodeapiUrl, uploadUrl } = config;

// Field-format validators for email / phone number inputs
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[6-9]\d{9}$/; // 10-digit Indian mobile number
const EMAIL_ERROR_MSG = "Please enter a valid email address !";
const PHONE_ERROR_MSG = "Please enter a valid 10-digit phone number !";
const EMAIL_FIELDS = ["user_email", "user_display_email"];
const PHONE_FIELDS = ["contact_no", "user_mobile"];

interface ICustomer {
    id: any;
}

const progressColor = {
    low: {
        backgroundColor: "green"

    } as CSSProperties,
    medium: {
        backgroundColor: "#a00505e0",

    } as CSSProperties,
    high: {
        backgroundColor: "red",

    } as CSSProperties,
}

const UpdateSeller = () => {
    let params: ICustomer = useParams();
    const { id } = params;
    // console.log(id);
    const decode = tokenDecode();
    const seller_id = decode?.data?.user?.seller_id
    const rawState = {
        "seller_id": id,
        "company_name": "",
        "contact_no": "",
        "provider_id": "",
        "logo": "",
        "status": true,
        "approve_status": 1,
        "short_description": "",
        "description": "",
        "seller_source": "",
        "pan_image": "",
        "pan_number": "",
        "gst_image": "",
        "gst_number": "",
        "user_name": "",
        "user_email": "",
        "user_mobile": "",
        "user_display_email": "",
        "brand_name": "",
        "state_code": "",
        "certification_image": "",
        "dms": "",
        "brands": [],
    }
    const rawErrorData = {
        "company_name": false,
        "contact_no": false,
        "user_name": false,
        "user_email": false,
    }
    const [sellerData, setSellerData]: any = useState(rawState);
    const [sellerDataError, setSellerDataError]: any = useState(rawErrorData);
    const errorHandler = (e: any) => {
        const { name, value } = e.target;
        const isRequired = ["user_email", "contact_no", "user_name", "company_name"].includes(name);
        if (!value) {
            setSellerDataError({ ...sellerDataError, [name]: isRequired ? true : "valid" });
        } else if (EMAIL_FIELDS.includes(name) && !EMAIL_REGEX.test(value.trim())) {
            setSellerDataError({ ...sellerDataError, [name]: EMAIL_ERROR_MSG });
        } else if (PHONE_FIELDS.includes(name) && !PHONE_REGEX.test(value.trim())) {
            setSellerDataError({ ...sellerDataError, [name]: PHONE_ERROR_MSG });
        } else {
            setSellerDataError({ ...sellerDataError, [name]: "valid" });
        }
    }


    // /profile is the ONLY source for the seller's identity/business/KYC fields.
    // /get-user-data is not used for the seller here — it only feeds the
    // Shop Details section (opening/closing time, days, holidays, fees).
    const fetchSellerData = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/profile`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    seller_id: id,
                    sellerId: id
                }
            });

            if (data.status === 200) {
                const business = data?.data?.business_details || {};
                const profile = data?.data?.profile || {};
                const kyc = data?.data?.kyc_details || {};

                setSellerData((prev: any) => ({
                    ...prev,
                    seller_id: id,
                    company_name: business.company_name || "",
                    contact_no: business.contact_no || "",
                    provider_id: business.provider_id || "",
                    logo: business.logo || "",
                    status: business.status !== undefined ? Boolean(business.status) : prev.status,
                    approve_status: business.approve_status ?? prev.approve_status,
                    short_description: business.short_description || "",
                    description: business.description || "",
                    seller_source: business.seller_source || "",
                    brand_name: business.brand_name || "",
                    state_code: business.state_code || "",
                    dms: business.dms || "",
                    brands: business.brands || [],
                    pan_number: kyc?.pan_no || (business.pan_number && business.pan_number !== "N/A" ? business.pan_number : ""),
                    pan_image: kyc?.pan_image || business.pan_image || "",
                    gst_number: kyc?.gst_no || (business.gst_number && business.gst_number !== "N/A" ? business.gst_number : ""),
                    gst_image: kyc?.gst_image || business.gst_image || "",
                    certification_image: kyc?.certification_image || business.certification_image || "",
                    user_name: profile.name || "",
                    user_email: profile.email || "",
                    user_mobile: profile.contact_no || profile.mobile || "",
                    user_display_email: profile.display_email || profile.user_display_email || "",
                }));
                setpageName(false);
            }
        } catch (error) {

        }
    }



    const inputSHandler = (e: any) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };
    const errorSHandler = (e: any) => {
        if (e.target.value) {
            setUserDataError({ ...userDataError, [e.target.name]: false });
        } else {
            setUserDataError({ ...userDataError, [e.target.name]: true });
        }
    }
    const inputHandler = (e: any) => {
        const { name, value } = e.target;
        // Phone fields: keep digits only, cap at 10
        const newValue = PHONE_FIELDS.includes(name) ? value.replace(/\D/g, "").slice(0, 10) : value;
        setSellerData({ ...sellerData, [name]: newValue });
    }

    const newUserCreatehandler = async () => {

    }
    const ImageHandler = async (e: any) => {
        try {
            const file = e.target.files[0];
            if (!file) return false;
            const formData = new FormData();
            formData.append("file", file);
            const { data } = await axios({
                url: `${uploadUrl}/upload`,
                method: "POST",
                headers: {
                    "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                data: formData
            });
            return data?.urls?.[0] || false;
        } catch (exception) {
            console.log(exception);
            return false;
        }
    };
    const uploadImage = async (e: any) => {
        const field = e.target.name;
        const image = await ImageHandler(e);
        // console.log(image);
        if (image) {
            setSellerData((prev: any) => ({ ...prev, [field]: image }));
        }
    }

    const [fraudDaata, setfraudDaata] = useState({
        provider_id: "",
        start_date: "",
        end_date: "",
        limit_count: "",
        limit_price: ""
    })
    const [fraudModalOpen, setfraudModalOpen] = useState(false);
    const [fraudLevel, setfraudLevel] = useState("")
    const [isAnalyzing, setisAnalyzing] = useState(false)
    const [sellerList, setSellerList] = useState([]);
    const [progressLevel, setProgressLevel] = useState('');

    function fraudChangeHandler(e: any) {
        setfraudDaata((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }
    function handleFraudModalClose() {
        setfraudModalOpen(false)
    }
    async function analyzerFunction() {
        setfraudLevel("")
        try {
            setisAnalyzing(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/analytics/fraudAnalytics_seller_order_count`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    ...fraudDaata
                }

            });
            setProgressLevel(data)
            if (data === "Low") {
                setfraudLevel("33%")
            }
            if (data === "Medium") {
                setfraudLevel("66%")
            }
            if (data === "High") {
                setfraudLevel("99%")
            }
            setisAnalyzing(false)
        } catch (error) {
            setisAnalyzing(false)
            console.log("error", error);
        }
    }
    const getColorClass = () => {
        if (progressLevel) {
            return `${progressLevel === 'Low' ? 'bg-success' : progressLevel === 'Medium' ? 'bg-warning' : 'bg-danger'}`;
        }
        return 'loading';
    };
    const preventMinus = (e: any) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };
    const Sstyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "10px",
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 2,
    };
    const steps = [
        'Low',
        'Medium',
        'High',
    ];
    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data.filter((item: any) => item.approve_status === 1));
                let providerId = data.data.filter((item: any) => item.id == id)

                setfraudDaata((prev) => {
                    return { ...prev, provider_id: providerId[0]?.provider_id }
                })
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month: string | number = today.getMonth() + 1;
        let day: string | number = today.getDate();

        // Add leading zero if month or day is a single digit
        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    //  --------------------------------------------------CODE FOR SHOP DETAILS START --------------------------------	
    const [Oweekdays, setOweekdays] = useState([
        { day: "Monday", id: "1" }, { day: "Tuesday", id: "2" }, { day: "Wednesday", id: "3" }, { day: "Thursday", id: "4" }, { day: "Friday", id: "5" }, { day: "Saturday", id: "6" }, { day: "Sunday", id: "7" },
    ])
    const [Cweekdays, setCweekdays] = useState([
        { cday: "Monday", id: "1" }, { cday: "Tuesday", id: "2" }, { cday: "Wednesday", id: "3" }, { cday: "Thursday", id: "4" }, { cday: "Friday", id: "5" }, { cday: "Saturday", id: "6" }, { cday: "Sunday", id: "7" },
    ])
    const [selectedCDays, setSelectedCDays] = useState();
    const [selectedODays, setSelectedODays] = useState(Oweekdays);
    const [startDate, setStartDate] = useState(new Date());
    const [selectedDates, setSelectedDates]: any = useState([]);
    const [pageNamem, setpageName] = useState(true);
    const rawData = {
        opening_time: '10:00',
        closing_days: "",
        opening_days: "",
        closing_time: '19:00',
        images: "",
        customer_care_contact: "",
        delivery_fee: "",
        packing_fee: "",
        status: true,
        holidays: "10-12-23"
    };
    const errorRawData = {
        opening_time: false,
        closing_days: false,
        opening_days: false,
        closing_time: false,
        incorporation_date: false,
        images: false,
        commission: false,
        ondc_commission: false,
        fssai_licence: false,
        seller_commission: false,
        returnable: false,
        replaceable: false,
        customer_care_contact: false,
        cancelable: false,
        return_window: false,
        seller_pickup_return: false,
        time_to_ship: false,
        cod: false,
        // status: false,	
        status: false
    };
    const [userData, setUserData]: any = useState(rawData);
    const [userDataError, setUserDataError] = useState(errorRawData);
    async function getDetails() {
        const { data } = await axios({
            url: `${apiEndpoint}/get-user-data`,
            method: "POST",
            headers: {
                "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
            },
            data: { seller_id: id, sellerId: id }
        })
        if (data.status === 200) {
            const info = data?.data || {};
            // /get-user-data only feeds the Shop Details section here — the seller's
            // identity/business/KYC fields come solely from /profile (fetchSellerData).
            setUserData((prev: any) => ({ ...prev, ...info }))
            setpageName(false);
            if (info?.holidays) {
                let t = info.holidays;
                let z = t?.split(",")
                setSelectedDates(z)
            }
            // Split opening_days and closing_days by comma and trim any whitespace
            const openingDays = (info?.opening_days || "").split(",").map((day: any) => day.trim());
            if (info?.closing_days) {
                const closingDays = info.closing_days.split(",").map((day: any) => day.trim());
                const filteredCDays: any = Cweekdays.filter(
                    (day) => closingDays?.includes(day.id)
                );
                setSelectedCDays(filteredCDays.map((item: any) => item));
            }
            const filteredODays = Oweekdays.filter(
                (day) => openingDays?.includes(day.id)
            );
            setSelectedODays(filteredODays.map((item: any) => item));
        }
    }
    const onSelectHandler = (selectedList: any, selectedItem: any) => {
        let daySelected = selectedList.map((item: any) => item.id);
        let z = daySelected.toString()
        setUserData({ ...userData, opening_days: z });
        setSelectedODays(selectedList.map((item: any) => item));
    }
    const onRemoveHandler = (selectedList: any, selectedItem: any) => {
        let daySelected = selectedList.map((item: any) => item.id);
        let z = daySelected.toString()
        setUserData({ ...userData, opening_days: z });
        setSelectedODays(selectedList.map((item: any) => item));
    }
    const handleDateSelect = async (date: any) => {
        setStartDate(date)
        let z = date;
        let c = z.toLocaleDateString()
        const dateStr = c;
        // Create a new Date object by parsing the date string	
        const dates = new Date(dateStr);
        // Extract the year, month, and day from the Date object	
        const year = dates.getFullYear();
        const month = String(dates.getMonth() + 1).padStart(2, '0');
        const day = String(dates.getDate()).padStart(2, '0');
        // Format the date in the desired format	
        const formattedDate = `${year}-${month}-${day}`;
        setSelectedDates((startDate: any) => [...startDate, formattedDate]);
    };
    const RemoveItem = (indexToRemove: any) => {
        let x = [...selectedDates]
        x.splice(indexToRemove, 1);
        setSelectedDates(x)
    }
    //  --------------------------------------------------CODE FOR SHOP DETAILS END ------------------------------------	

    const updateSellerHandlre = async () => {
        const { company_name, contact_no, user_name, user_email } = sellerData;

        const nextErrors = {
            company_name: !company_name,
            contact_no: !contact_no,
            user_name: !user_name,
            user_email: !user_email,
        };
        setSellerDataError((prev: any) => ({ ...prev, ...nextErrors }));

        if (nextErrors.company_name || nextErrors.contact_no || nextErrors.user_name || nextErrors.user_email) {
            toast.error("Please fill all the required fields !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }

        const { user_mobile, user_display_email } = sellerData;
        if (user_email && !EMAIL_REGEX.test(String(user_email).trim())) {
            toast.error(EMAIL_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError((prev: any) => ({ ...prev, user_email: EMAIL_ERROR_MSG }));
            return;
        }
        if (user_display_email && !EMAIL_REGEX.test(String(user_display_email).trim())) {
            toast.error(EMAIL_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError((prev: any) => ({ ...prev, user_display_email: EMAIL_ERROR_MSG }));
            return;
        }
        if (contact_no && !PHONE_REGEX.test(String(contact_no).trim())) {
            toast.error(PHONE_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError((prev: any) => ({ ...prev, contact_no: PHONE_ERROR_MSG }));
            return;
        }
        if (user_mobile && !PHONE_REGEX.test(String(user_mobile).trim())) {
            toast.error(PHONE_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError((prev: any) => ({ ...prev, user_mobile: PHONE_ERROR_MSG }));
            return;
        }

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/update-user-data`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { ...sellerData, sellerId: id }
            });
            if (data.status === 200) {
                toast.success("Seller updated successfully !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error(data.message || "403 error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            toast.error("403 error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
    useEffect(() => {
        // fetchSellerData() (/profile) is the sole source for the seller's
        // identity/business/KYC fields; getDetails() (/get-user-data) only
        // populates the Shop Details section. They no longer write the same
        // fields, so the order between them doesn't matter.
        (async () => {
            await getDetails();
            await fetchSellerData();
        })();
        getSellerList();
    }, []);

    console.log("progressLevel", progressLevel)
    console.log("getColorClass()", getColorClass())
    return (
        <>
            <ThemeMaker>

                <div className={styles.pageWrap}>
                    <div className={brandStyles.cardOuter}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>Update Seller</span>
                            <Link to="/sellerlist" className={brandStyles.primaryBtn}>Seller List</Link>
                        </div>

                        <div className={`${brandStyles.bodyArea} ${styles.formBody}`}>
                            <p className={styles.sectionTitle}>Login Details</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Name<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.user_name !== "valid" && sellerDataError?.user_name !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="user_name" placeholder="Enter name"
                                            value={sellerData.user_name}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Email address<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.user_email !== "valid" && sellerDataError?.user_email !== false ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.user_email === true ? "This field is required !" : sellerDataError?.user_email}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" name="user_email" className={brandStyles.input} placeholder="Enter email"
                                            value={sellerData.user_email}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Alternate Mobile Number
                                            {sellerDataError?.user_mobile && sellerDataError?.user_mobile !== "valid" ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.user_mobile === true ? "This field is required !" : sellerDataError?.user_mobile}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" inputMode="numeric" maxLength={10} name="user_mobile" className={brandStyles.input} placeholder="Enter alternate mobile"
                                            value={sellerData.user_mobile}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>User Display Email
                                            {sellerDataError?.user_display_email && sellerDataError?.user_display_email !== "valid" ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.user_display_email === true ? "This field is required !" : sellerDataError?.user_display_email}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" name="user_display_email" className={brandStyles.input} placeholder="Enter display email"
                                            value={sellerData.user_display_email}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <p className={styles.sectionTitle}>Business Details</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Company name<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.company_name !== "valid" && sellerDataError?.company_name !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="company_name" placeholder="Enter company name"
                                            value={sellerData.company_name}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div> 
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Contact No.<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.contact_no !== "valid" && sellerDataError?.contact_no !== false ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.contact_no === true ? "This field is required !" : sellerDataError?.contact_no}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" inputMode="numeric" maxLength={10} name="contact_no" className={brandStyles.input} placeholder="Enter contact number"
                                            value={sellerData.contact_no}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Provider ID</label>
                                        <input type="text" className={brandStyles.input} name="provider_id" value={sellerData.provider_id} disabled />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Seller Source</label>
                                        <input type="text" className={brandStyles.input} name="seller_source" value={sellerData.seller_source} disabled />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Brand Name</label>
                                        <input type="text" className={brandStyles.input} name="brand_name" placeholder="Enter brand name"
                                            value={sellerData.brand_name}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>State Code</label>
                                        <input type="text" className={brandStyles.input} name="state_code" placeholder="Enter state code"
                                            value={sellerData.state_code}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Logo
                                            {sellerData.logo && <a href={sellerData.logo} target="_blank" rel="noreferrer" className={brandStyles.viewDocLink}>View Document</a>}
                                        </label>
                                        <input type="file" name="logo" className={brandStyles.fileInput} onChange={(e) => uploadImage(e)} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Status</label>
                                        <select className={brandStyles.input} name="status"
                                            onChange={(e) => setSellerData({ ...sellerData, status: e.target.value === "true" })}
                                            value={String(sellerData.status)}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">Deactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Approve Status</label>
                                        <select className={brandStyles.input} name="approve_status"
                                            onChange={(e) => setSellerData({ ...sellerData, approve_status: Number(e.target.value) })}
                                            value={sellerData.approve_status}
                                        >
                                            <option value="0">New Request</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Short description</label>
                                        <input type="text" className={brandStyles.input} name="short_description" placeholder="Enter short description"
                                            value={sellerData.short_description}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Long description</label>
                                        <input type="text" className={brandStyles.input} name="description" placeholder="Enter long description"
                                            value={sellerData.description}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <p className={styles.sectionTitle}>KYC Details</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>PAN Number
                                            <span className={styles.verifiedTag}>Verified <VerifiedIcon style={{ fontSize: "12px" }} /></span>
                                        </label>
                                        <input type="text" className={brandStyles.input} name="pan_number" placeholder="Enter PAN number"
                                            value={sellerData.pan_number}
                                            onChange={(e) => inputHandler(e)}
                                            maxLength={10}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>PAN image
                                            {sellerData.pan_image && <a href={sellerData.pan_image} target="_blank" rel="noreferrer" className={brandStyles.viewDocLink}>View Document</a>}
                                        </label>
                                        <input type="file" name="pan_image" className={brandStyles.fileInput} onChange={(e) => uploadImage(e)} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>GST Number
                                            <span className={styles.verifiedTag}>Verified <VerifiedIcon style={{ fontSize: "12px" }} /></span>
                                        </label>
                                        <input type="text" className={brandStyles.input} name="gst_number" placeholder="Enter GST number"
                                            value={sellerData.gst_number}
                                            onChange={(e) => inputHandler(e)}
                                            maxLength={15}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>GST image
                                            {sellerData.gst_image && <a href={sellerData.gst_image} target="_blank" rel="noreferrer" className={brandStyles.viewDocLink}>View Document</a>}
                                        </label>
                                        <input type="file" name="gst_image" className={brandStyles.fileInput} onChange={(e) => uploadImage(e)} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Certification image
                                            {sellerData.certification_image && <a href={sellerData.certification_image} target="_blank" rel="noreferrer" className={brandStyles.viewDocLink}>View Document</a>}
                                        </label>
                                        <input type="file" name="certification_image" className={brandStyles.fileInput} onChange={(e) => uploadImage(e)} />
                                    </div>
                                </div>
                            </div>

                            <p className={styles.sectionTitle}>Shop Details</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Opening Time<span className={brandStyles.required}>*</span>
                                            {userDataError?.opening_time ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input
                                            type="time"
                                            className={brandStyles.input}
                                            name="opening_time"
                                            placeholder="Enter Opening Time"
                                            value={userData?.opening_time}
                                            onChange={(e: any) => inputSHandler(e)}
                                            onBlur={(e: any) => errorSHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Closing Time<span className={brandStyles.required}>*</span>
                                            {userDataError?.closing_time ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input
                                            type="time"
                                            name="closing_time"
                                            className={brandStyles.input}
                                            placeholder="Enter Closing Time"
                                            value={userData?.closing_time}
                                            onChange={(e: any) => inputSHandler(e)}
                                            onBlur={(e: any) => errorSHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Delivery Charges</label>
                                        <input
                                            type="text"
                                            name="delivery_fee"
                                            className={brandStyles.input}
                                            value={userData?.delivery_fee}
                                            onChange={(e: any) => inputSHandler(e)}
                                            onBlur={(e: any) => errorSHandler(e)}
                                            placeholder="Enter Delivery Charges"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Packing Charges</label>
                                        <input
                                            type="text"
                                            name="packing_fee"
                                            className={brandStyles.input}
                                            value={userData?.packing_fee}
                                            onChange={(e: any) => inputSHandler(e)}
                                            onBlur={(e: any) => errorSHandler(e)}
                                            placeholder="Enter Packing Charges"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={`${brandStyles.field} ${styles.field}`}>
                                        <label className={brandStyles.label}>Opening Days<span className={brandStyles.required}>*</span>
                                            {userDataError?.opening_days !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <Multiselect options={Oweekdays} selectedValues={selectedODays} displayValue="day" onSelect={onSelectHandler} onRemove={onRemoveHandler}></Multiselect>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={`${brandStyles.field} ${styles.field}`}>
                                        <label className={brandStyles.label}>Closing Days</label>
                                        <Multiselect options={Cweekdays} selectedValues={selectedCDays} displayValue="cday" onSelect={(selectedList, selectedItem) => {
                                            let daySelected = selectedList.map((item: any) => item.id)
                                            let z = daySelected.toString()
                                            setUserData({ ...userData, closing_days: z });
                                            setSelectedCDays(selectedList.map((item: any) => item));
                                        }}
                                            onRemove={(selectedList, selectedItem) => {
                                                let daySelected = selectedList.map((item: any) => item.id);
                                                let z = daySelected.toString()
                                                setUserData({ ...userData, closing_days: z });
                                                setSelectedCDays(selectedList.map((item: any) => item));
                                            }}></Multiselect>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Holidays</label>
                                        <div className={styles.datePickerWrap}>
                                            <DatePicker selected={startDate} onChange={(date) => handleDateSelect(date)} />
                                        </div>
                                        <div className={styles.holidayList}>
                                            {selectedDates?.map((date: any, index: any) => (
                                                <span key={date.toString()} className={styles.holidayChip}>
                                                    {date}
                                                    <span className={styles.holidayRemove} onClick={() => RemoveItem(index)}>×</span>
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.submitRow}>
                                <button type="submit" className={brandStyles.updateBtn} style={{ width: "220px" }}
                                    onClick={updateSellerHandlre}>
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ------------------  FRAUD MODAL -------------------------- */}
                <>
                    <Modal
                        open={fraudModalOpen}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-3 w-75 w-md-25">
                            <div className="modal-content ">
                                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                                    <p className="modal-title genericlabel  " style={{ letterSpacing: "3px" }}>Fraud Analysys:</p>
                                    <div className="d-flex align-items-center" style={{ gap: "14px" }}>


                                        {(fraudDaata.provider_id && fraudDaata.limit_count) && <span className="d-block text-center" style={{ width: "60px", padding: "1px", cursor: "pointer", borderRadius: "20px", fontSize: "12px", background: "lightgrey", height: "20px" }} onClick={() => {
                                            setfraudDaata({
                                                provider_id: "",
                                                start_date: "",
                                                end_date: "",
                                                limit_count: "",
                                                limit_price: ""
                                            });
                                            setfraudLevel("")
                                        }} >Clear</span>}


                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleFraudModalClose} /></span>
                                        </button>

                                    </div>

                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label htmlFor="" className="genericlabel" >Choose Seller</label> <span className="text-danger" > * </span>
                                        <select name="provider_id" id="" className="form-control" value={fraudDaata.provider_id} onChange={fraudChangeHandler}>
                                            <option value="" disabled selected >Select Seller</option>
                                            {
                                                sellerList.map((item: any) => (
                                                    <option value={item?.provider_id} key={item?.seller_id}>{item?.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>

                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Order Limit</label> <span className="text-danger" > * </span>
                                        <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_count} name="limit_count" className="form-control" onChange={fraudChangeHandler} />
                                    </div>
                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Price Limit</label> <span className="text-danger" > * </span>
                                        <input type="number" min={0} onKeyPress={preventMinus} value={fraudDaata.limit_price} name="limit_price" className="form-control" onChange={fraudChangeHandler} />
                                    </div>

                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >Start Date</label> <span className="text-danger" > * </span>
                                        <input type="date" value={fraudDaata.start_date} name="start_date" className="form-control" max={getCurrentDate()} onChange={fraudChangeHandler} />
                                    </div>
                                    <div className="mt-2">
                                        <label htmlFor="" className="genericlabel" >End Date</label> <span className="text-danger" > * </span>
                                        <input type="date" value={fraudDaata.end_date} name="end_date" className="form-control" max={getCurrentDate()} onChange={fraudChangeHandler} />
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    {/* <button type="button" className="btn btn-danger" onClick={() => {
                                        fetchSellerList(); setshipmentModalOpen(false); setfilterDaata({
                                            seller_id: "",
                                            orderCurrentStatus: "",
                                            endDate: ""
                                        })
                                    }} >Clear Filter</button> */}
                                    <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={analyzerFunction} disabled={(fraudDaata.end_date && fraudDaata.start_date && fraudDaata.limit_count && fraudDaata.limit_price && fraudDaata.provider_id) ? false : true} >{isAnalyzing ? "Please Wait.." : "Analyze"}</button>

                                    {fraudLevel !== "" && <div className="" style={{ width: "60%" }}>

                                        <div>
                                            <div className="progress">
                                                {/* (item: any) => */}
                                                <div className={`progress-bar ${getColorClass()}`} role="progressbar" style={{ width: `${fraudLevel}` }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                            <div className="d-flex justify-content-around mt-2" >
                                                {steps.map((item, index) => {
                                                    return <span className="genericlabel" key={index} >{item}</span>
                                                })}
                                            </div>
                                        </div>
                                    </div>}

                                </div>


                            </div>
                        </Box>
                    </Modal>
                </>

                {/* ------------------  FRAUD MODAL -------------------------- */}

            </ThemeMaker>
        </>
    )
}

export default UpdateSeller;